module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "pz8-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_04",
      "id": "CC_04"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz8-2"
    }
  }, [_vm._v("Aunt Bee is known far and wide for her cooking of all kinds, but if you were to ask Andy and Opie and Barney and Goober where Aunt Bee really shines, they’d most certainly agree it’s her desserts. Of course, you might get that answer in part because desserts happen to be their favorite part of the meal. But either way, Aunt Bee’s desserts win blue ribbons every time. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-3"
    }
  }, [_vm._v("And so, following the warm response to our original "), _c('i', [_vm._v("Aunt Bee’s Mayberry Cookbook")]), _vm._v(" (Thomas Nelson, 1991), a complete cookbook of everything from appetizers through desserts, we thought it would be fitting to devote a new cookbook to the sweetness of Mayberry. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-4"
    }
  }, [_vm._v("Once again we have gathered recipes from folks who share both a fondness for Mayberry and a knack for cooking. Within these pages, you’ll find more than 350 recipes from some of the country’s best cooks and most devoted Mayberry fans. Many of these recipes—all of which are different from those in "), _c('i', [_vm._v("Aunt Bee’s Mayberry Cookbook")]), _vm._v("—have been family favorites for generations. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-5"
    }
  }, [_vm._v("We’ve selected recipes that are representative of the kinds of down-home desserts you’d expect to find Aunt Bee making. But you’ll also find quite a few that can be mastered by Opie and Goober, and even Ernest T. Bass. And we’ve blended in recipes that we learned about in neighboring Mt. Pilot and down the road in Raleigh, so you’ll discover an occasional “big city” taste that we think you’ll really enjoy. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-6"
    }
  }, [_vm._v("This cookbook is meant to be a tribute (through recipes) to all of the talented people who helped make Mayberry such an appealing place. For that reason, we’re especially pleased to be able to include recipes from more than forty of the show’s actors, writers, production crew members, and their families. They’ve submitted some of their personal favorites, as well as ones that they think might be appropriate for their part in Mayberry. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-7"
    }
  }, [_vm._v("Beyond the outstanding recipes, we’ve also tried to make this cookbook one that’ll be as inviting just to sit down and read as it is to use for cooking. We’ve included more than a hundred photos (many rarely before seen) and lots of dialogue about food, eating, and cooking, plus trivia and other reading that we hope you’ll find interesting and fun. There’s even a checklist of episode summaries to help you maintain a balanced diet of "), _c('i', [_vm._v("Andy Griffith Show")]), _vm._v(" reruns. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-8"
    }
  }, [_vm._v("And just as desserts are the crowning glory of a good meal, this book has a happy ending in that a portion of the proceeds will support the efforts of the National Court Appointed Special Advocate Association (CASA), which assists children in need (read more about the program and its ties to Mayberry in the back of this book). ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-9"
    }
  }, [_vm._v("We appreciate your coming to Mayberry for a visit, and we hope you’ll come back often. But eating speaks louder than words, so let’s see what mouthwatering desserts and happy memories Aunt Bee and friends have in store for us in the friendly town of Mayberry. ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "pz8-10"
    }
  }, [_vm._v("—Ken Beck and Jim Clark ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b72a6a0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter04.vue
// module id = 75
// module chunks = 0